/* unplugin-vue-components disabled */import { render } from "./company.vue?vue&type=template&id=67882a42&scoped=true"
import script from "./company.vue?vue&type=script&setup=true&lang=js"
export * from "./company.vue?vue&type=script&setup=true&lang=js"

import "./company.vue?vue&type=style&index=0&id=67882a42&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67882a42"],['__file',"src/components/cards/company/company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67882a42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67882a42', __exports__)) {
    api.reload('67882a42', __exports__)
  }
  
  module.hot.accept("./company.vue?vue&type=template&id=67882a42&scoped=true", () => {
    api.rerender('67882a42', render)
  })

}


export default __exports__